export const messages = {
  en: {
    mallUser: {
      queryCondition: 'Query Condition',
      namePlaceholder: 'Please enter name',
      telPlaceholder: 'Please enter phone',
      query: 'Query',
      title: 'Mall User',
      userId: 'User ID',
      name: 'Name',
      email: 'Email',
      address: 'Address',
      tel: 'Phone',
      createTime: 'Registration Time'
    },
    resetMallUserPwd: {
      confirmTitle: 'Confirm',
      confirmContent: 'Are you sure you want to reset the password?'
    }
  },
  zh: {
    mallUser: {
      queryCondition: '查询条件',
      namePlaceholder: '请输入名称',
      telPlaceholder: '请输入手机号',
      query: '查询',
      title: '商城用户',
      userId: '用户编号',
      name: '名称',
      email: '邮箱',
      address: '地址',
      tel: '手机号',
      createTime: '注册时间'
    },
    resetMallUserPwd: {
      confirmTitle: '确认',
      confirmContent: '确定要重置密码吗？'
    }
  }
}